import axios from "axios";

axios.defaults.headers.common = {
    'X-Requested-With' : 'XMLHttpRequest',
    'X-CSRF-TOKEN'     : document.querySelector( 'meta[name="csrf-token"]' ).getAttribute( 'content' ),
};

export default class AdfSearchBar
{

    constructor ()
    {
        this.isSearchPage = document.querySelector( 'body' ).classList.contains( 'search-page' );


        this.isSearching = 0;

        this.bindEvents();

        this.isMobileOpen = false;

        this.populateHistory();

        this.searchDropdownOpen     = false;
        this.popularKeywordsOpen    = false;
        this.searchAutocompleteOpen = false;
    }


    bindEvents ()
    {
        this.searchInput                   = document.querySelector( "#nav-search-input" );
        this.searchDropdown                = document.querySelector( "#search-dropdown" );
        this.popularKeywords               = document.querySelector( "#popular-keywords" );
        this.searchAutocomplete            = document.querySelector( "#search-autocomplete" );
        this.all_list_history_autocomplete = document.querySelector( "#all_list_history_autocomplete" );
        this.list_history_autocomplete     = document.querySelector( "#list_history_autocomplete" );
        this.list_keywords_autocomplete    = document.querySelector( "#list_keywords_autocomplete" );
        this.hr_autocomplete               = document.querySelector( "#hr_autocomplete" );
        this.hr_history                    = document.querySelector( "#hr_history" );

        this.containerSearchSection = document.querySelector( '#container-search' );
        this.headerSearchSection    = document.querySelector( '#nav-search-section' );
        this.searchFieldContainer   = this.headerSearchSection.querySelector( '.input-inner' );

        this.btnPopularKeywords    = Array.from( document.querySelectorAll( '[data-popular-keyword]' ) );
        this.btnSearchSubmit       = this.headerSearchSection.querySelector( 'button[type=submit]' );
        this.btnSearchReset        = this.headerSearchSection.querySelector( '.btn-search-reset' );
        this.btnMobileToggleSearch = document.querySelector( '#nav-search-mobile-toggle' );


        this.searchInput.addEventListener( "keyup", this.onKeypress.bind( this ) );
        this.headerSearchSection.addEventListener( "submit", this.onSubmit.bind( this ) );
        // moved the blur/focus into its own thing...
        this.bindInputAreaEvents();
        this.btnMobileToggleSearch.addEventListener( 'click', this.handleMobileToggle.bind( this ) );

        this.btnPopularKeywords.forEach( btn =>
        {
            btn.addEventListener( "click", ( e ) => this.onKeywordClick( e ) )
        } )


        document.addEventListener( 'click', this.onBlur.bind( this ) );

        // mobile search toggle


    }


    // moved it in here because I had to make it more complex for a11y
    bindInputAreaEvents ()
    {


        this.containerSearchSection.addEventListener( 'focusin', this.onFocus.bind( this ) );
        this.containerSearchSection.addEventListener( 'focusout', this.onBlur.bind( this ) );

        document.addEventListener( 'keydown', this.maybeKeypressClose.bind( this ) );

        this.btnSearchReset.addEventListener('click', () => {
            this.searchInput.focus();
            this.onKeypress(null);
        })
    }

    handleMobileToggle ()
    {
        if ( this.isMobileOpen )
        {
            this.closeMobile();
        } else
        {
            this.openMobile();
        }
    }


    openMobile ()
    {

/*console.log(('AdfSearchBar:openMobile'))*/;        this.isMobileOpen = true;
        this.searchFieldContainer.classList.remove( 'closed' );
        this.searchFieldContainer.classList.add( 'open' );

        this.btnSearchReset.setAttribute( 'tabindex', 0 );
        this.searchInput.focus();
    }

    closeMobile ()
    {

/*console.log(('AdfSearchBar:closeMobile'))*/;

        this.isMobileOpen = false;
        this.searchFieldContainer.classList.remove( 'open' );
        this.searchFieldContainer.classList.add( 'closed' );

        this.btnSearchReset.setAttribute( 'tabindex', -1 );
    }

    populateHistory ()
    {
        let strHistory = window.localStorage.getItem( "historique" ) ?? "[]";
        let history    = JSON.parse( strHistory );

        //we keep the last five result compatible with this search
        let historyResults = history
            .filter( h => h.searchTerm )
            .sort( ( a, b ) => b.date - a.date )
            .slice( 0, 5 );

        this.all_list_history_autocomplete.innerHTML = "";
        this.fillHistory( historyResults, this.all_list_history_autocomplete )

        if ( historyResults.length === 0 )
        {
            this.hr_history.classList.add( "d-none" );
        }
    }

    onFocus ( event )
    {

        // console.log( 'FOCUS', event );

        // don't want to hide until we really focus outside of the whole area
        // if ( !this.headerSearchSection.contains( event.target ) )
        // {
        //     console.log( 'Within the search area... turning on the "focused" state ', event.target );
        //     return;
        // }

        this.isFocused = true;

        if ( this.blurTimeout )
        {
            clearTimeout( this.blurTimeout );
            delete this.blurTimeout;
        }

        this.searchDropdown.classList.remove( "d-none" );

        if ( this.searchInput.value.length === 0 )
        {
            this.popularKeywords.classList.remove( "d-none" );
            this.popularKeywordsOpen = true;

            this.searchDropdown.classList.remove( "d-none" );
            this.searchDropdownOpen = true;
        } else
        {
            this.searchAutocomplete.classList.remove( "d-none" );
            this.searchAutocompleteOpen = true;

            this.searchDropdown.classList.remove( "d-none" );
            this.searchDropdownOpen = true;
        }


        this.btnSearchReset.setAttribute( 'tabindex', 0 );
        this.btnSearchReset.classList.add( 'open' );


    }

    onBlur ( event, delay = 250 )
    {
/*console.log(( 'onBlur', event.type , event.target, event.relatedTarget, this.containerSearchSection.contains( event.target ), event ))*/;        // don't want to hide until we really focus outside of the whole area
        // https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent/relatedTarget
        if (
            (event.type === 'keydown' && (!event.relatedTarget || this.containerSearchSection.contains( event.relatedTarget )))
            || (event.type === 'click' && this.containerSearchSection.contains( event.target ))
            || (event.type === 'focusout' && this.containerSearchSection.contains( event.relatedTarget ))
        )
        {
/*console.log(( 'Still within the search area... keeping the "focused" state ', event.relatedTarget ))*/;            if ( this.blurTimeout )
            {
                clearTimeout( this.blurTimeout );
                delete this.blurTimeout;
            }
            return true;
        }


        this.isFocused = false;

        // console.log( 'BLUR', event );

        //we still want to be able to click on item in the popup
        this.blurTimeout = setTimeout( () =>
        {
            this.searchDropdown.classList.add( "d-none" );
            this.searchDropdownOpen = false;

            this.popularKeywords.classList.add( "d-none" );
            this.popularKeywordsOpen = false;

            this.searchAutocomplete.classList.add( "d-none" );
            this.searchAutocompleteOpen = false;

            this.searchInput.classList.remove( "search" )

            this.closeMobile();
        }, delay );

        this.btnSearchReset.setAttribute( 'tabindex', -1 );
        this.btnSearchReset.classList.remove( 'open' );
    }

    onSubmit ( e )
    {
        if ( this.isSearchPage )
        {
            e.preventDefault();

            let searchTerm = this.searchInput.value ?? "";
            this.searchEvent( "plain", searchTerm )

        }

        this.onBlur( null, 1 );


        // let's not make the closing too jarring THE MOMENT the field is submitted.
        setTimeout( () =>
        {
            this.closeMobile();
        }, 500 );

    }

    searchEvent ( type, searchTerm, searchId )
    {
        let event = new CustomEvent( "adf-search", { detail : { type, searchTerm, searchId } } );
        window.dispatchEvent( event )
    }

    maybeKeypressClose ( event )
    {
        if ( this.isFocused && event.which === 27 )
        {

            const userIconLink = document.querySelector( '#header-link-user' );
            if ( userIconLink )
            {
                userIconLink.focus();
            }

        }


    }

    async onKeypress ( event )
    {

        // This was interfering with keyboard navigation,
        // adding a little exception
        // ignore TAB (9) and ESC (27)
        if ( [ 9, 27 ].includes( event.which ) )
        {
            // not counting "tab" as a valid keystroke for search
            return true;
        } else if ( event.which === 27 )
        {
            const userIconLink = document.querySelector( '#header-link-user' );
            if ( userIconLink )
            {
                userIconLink.focus();
            }
            // this.onBlur( event );
        }

        let search       = this.searchInput.value;
        let shouldSearch = search.length >= 2;

        if ( shouldSearch )
        {
            this.isSearching++;
            this.searchInput.classList.add( "search" )
            // this.searchAutocomplete.classList.remove( "d-none" );
            this.popularKeywords.classList.add( "d-none" );
            this.popularKeywordsOpen = false;

            let response = await axios.get( "/endpoints/autocomplete?s=" + search );

            this.isSearching--;

            if ( this.isSearching === 0 )
            {
                this.searchInput.classList.remove( "search" )
            }

            //Fill the history
            let strHistory = window.localStorage.getItem( "historique" ) ?? "[]";
            let history    = JSON.parse( strHistory );

            //we keep the last five result compatible with this search
            let historyResults = history
                .filter( h => h.searchTerm )
                .filter( h => (h?.searchTerm ?? "").indexOf( search ) > -1 )
                .sort( ( a, b ) => b.date - a.date )
                .slice( 0, 5 );

            if ( historyResults.length > 0 )
            {
                this.list_history_autocomplete.innerHTML = "";
                this.fillHistory( historyResults, this.list_history_autocomplete )
            }

            let list = response.data;


            if ( list.length > 0 )
            {
                let template = document.querySelector( "template#tag_autocomplete" );

                this.list_keywords_autocomplete.innerHTML = "";

                //Fill the autocomplete list with keywords
                for ( let i = 0; i < list.length; i++ )
                {
                    let tag = template.content.cloneNode( true );

                    let title       = tag.querySelector( "span" );
                    title.innerText = list[ i ].keyword;

                    let a                                = tag.querySelector( "a" );
                    a.href                               = "/recherche?s=" + list[ i ].keyword + "&type=mot_cle";
                    a.attributes[ "data-keyword" ].value = list[ i ].keyword;
                    a.addEventListener( "click", ( e ) => this.onKeywordClick( e ) )


                    this.list_keywords_autocomplete.append( tag );


                }


            }

            // console.log( 'historyResults', historyResults, 'list', list );


            if ( historyResults.length > 0 || list.length > 0 )
            {
                this.searchAutocomplete.classList.remove( "d-none" );
                this.searchAutocompleteOpen = true;

                this.searchDropdown.classList.remove( 'd-none' );
                this.searchDropdownOpen = true;
            } else

                // no results returned
            {
                this.searchAutocomplete.classList.add( "d-none" );
                this.searchAutocompleteOpen = false;

                this.searchDropdown.classList.add( 'd-none' );
                this.searchDropdownOpen = false;
            }

        } else
        {
            this.searchInput.classList.remove( "search" )

            this.searchAutocomplete.classList.add( "d-none" );
            this.searchAutocompleteOpen = false;

            this.popularKeywords.classList.remove( "d-none" );
            this.popularKeywordsOpen = true;

            this.searchDropdown.classList.add( 'd-none' );
            this.searchDropdownOpen = true;
        }


    }

    fillHistory ( historyResults, elList )
    {
        let templateHistory = document.querySelector( "template#tag_history" );

        //Fill the autocomplete list with keywords
        for ( let i = 0; i < historyResults.length; i++ )
        {
            let tag = templateHistory.content.cloneNode( true );
            let h   = historyResults[ i ];

            let title       = tag.querySelector( "span" );
            title.innerText = h.searchTerm;

            let a = tag.querySelector( "a" );

            if ( h.searchType === "descripteurs" )
            {
                a.href = "/recherche?descripteurs=" + h.searchTerm + "&type=descripteurs" + "&id=" + h.searchId;
            } else
            {
                a.href = "/recherche?s=" + h.searchTerm;
            }

            a.attributes[ "data-type" ].value = h.searchType;
            a.attributes[ "data-term" ].value = h.searchTerm;
            a.attributes[ "data-id" ].value   = h.searchId ?? "0";

            a.addEventListener( "click", ( e ) => this.onHistoryClick( e ) )


            elList.append( tag );


        }
    }

    onHistoryClick ( e )
    {

        if ( this.isSearchPage )
        {
            e.preventDefault();

            let target = e.target;

            let parent = e.target.closest( "[data-type]" );

            if ( parent )
            {

                let searchType = parent.attributes[ "data-type" ].value ?? 'plain';
                let searchTerm = parent.attributes[ "data-term" ].value ?? '';
                let searchId   = parent.attributes[ "data-id" ].value ?? '';

                if ( searchType === '' )
                {
                    searchType = "plain";
                }

                this.searchEvent( searchType, searchTerm, searchId );

                // if (e.target && e.target.attributes["data-keyword"])
                // {
                //     let keyword = e.target.attributes["data-keyword"].value ?? "";
                //     this.searchEvent("keyword", keyword);
                // }

                let related = document.querySelector( ".related-subject" );
                related.classList.add( "d-none" );
            }

        }

    }


    onKeywordClick ( e )
    {
        if ( this.isSearchPage )
        {


            let parent = e.target.closest( "[data-keyword]" );

            if ( parent )
            {
                e.preventDefault();
                let keyword = parent.attributes[ "data-keyword" ].value ?? "";
                this.searchEvent( "keyword", keyword );

                let related = document.querySelector( ".related-subject" );
                related.classList.add( "d-none" );
            }


        }

    }

}
